import CommonHttp from './../service/common-http';

class CommonHttpProvider {
    constructor() {
        this.defaultConfig = {};
    }

    setDefaultConfig(defaultConfig) {
        this.defaultConfig = defaultConfig;
    }

    /*@ngInject*/
    $get(commonHttpFactory) {
        return commonHttpFactory.createCommonHttp(this.defaultConfig);
    }
}

export default CommonHttpProvider;